<template>
  <div class="container">
    <button class="button is-primary" @click="toggleModal">
      Add Future Item
    </button>
    <div class="modal has-text-left" v-bind:class="{ 'is-active': isActive }">
      <div class="modal-background" @click="toggleModal"></div>
      <div class="modal-card">
        <header class="modal-card-head">Add Future Income/Expense</header>
        <section class="modal-card-body">
          <label for="desc">Description:</label>
          <input
            id="desc"
            type="text"
            class="input"
            placeholder="Description"
            v-model="new_desc"
          />
          <label for="amt">Amount:</label>
          <input
            id="amt"
            type="number"
            class="input"
            placeholder="Amount"
            v-model="new_amt"
          />
          <label for="begin">Month it Begins:</label>
          <input
            id="begin"
            type="number"
            min="0"
            class="input"
            placeholder="Month it Begins"
            v-model="new_mon"
          />
          <p class="gots-issues">{{ feedback }}</p>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" @click="addFuture">Add It</button>
          <button class="button" @click="toggleModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddFuture",
  data() {
    return {
      isActive: false,
      new_desc: null,
      new_amt: null,
      new_mon: null,
      feedback: null,
    };
  },
  methods: {
    toggleModal() {
      this.isActive = !this.isActive;
      this.feedback = null;
    },
    addFuture() {
      console.log("here");
      if (this.new_desc && this.new_amt && this.new_mon) {
        let item = {
          name: this.new_desc,
          amount: Number(this.new_amt),
          month: Number(this.new_mon),
        };
        this.new_desc = null;
        this.new_amt = null;
        this.new_mon = null;
        this.feedback = null;
        this.$emit("add-fut", item);
        this.toggleModal();
      } else {
        this.feedback = "Hmm, it looks like something is missing";
      }
    },
  },
};
</script>

<style>
</style>